import React, { useState } from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Frontend only - show success message
    toast.success('Thank you for contacting us! We will get back to you shortly.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header">
        <h1 className="page-title">Contact Us</h1>
        <p className="page-subtitle">
          Get in touch with us to discuss how we can help your business grow
        </p>
      </section>

      {/* Contact Content */}
      <section className="contact-section">
        <div className="contact-grid">
          {/* Contact Information */}
          <div className="contact-info">
            <h2 className="contact-info-title">Get In Touch</h2>
            <p className="contact-info-text">
              Have a question or want to discuss a project? We'd love to hear from you. 
              Fill out the form or use our contact information below.
            </p>

            <div className="contact-details">
              <div className="contact-detail-item">
                <div className="contact-detail-icon">
                  <MapPin size={24} />
                </div>
                <div>
                  <h3 className="contact-detail-title">Office Address</h3>
                  <p className="contact-detail-text">
                    StoryBox Solutions Pvt. Ltd.<br />
                    Koramangala, Bangalore<br />
                    Karnataka 560034, India
                  </p>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-detail-icon">
                  <Phone size={24} />
                </div>
                <div>
                  <h3 className="contact-detail-title">Phone</h3>
                  <p className="contact-detail-text">+91 88 4847 6045</p>
                  <p className="contact-detail-text">+91 755 986 8055</p>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-detail-icon">
                  <Mail size={24} />
                </div>
                <div>
                  <h3 className="contact-detail-title">Email</h3>
                  <p className="contact-detail-text">info@storyboxsolutions.com</p>
                  <p className="contact-detail-text">sales@storyboxsolutions.com</p>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-detail-icon">
                  <Clock size={24} />
                </div>
                <div>
                  <h3 className="contact-detail-title">Business Hours</h3>
                  <p className="contact-detail-text">Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p className="contact-detail-text">Saturday: 10:00 AM - 2:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="form-label">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="company" className="form-label">Company Name</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="form-textarea"
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn-submit">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
